import { xExtendClassForDOM, XTemplateDOM } from './XDOM.js';
import { xArray, xInteger, xObject, xReference, xString } from './XTypes.js';

import template from './XPageSettingsSite.html?raw';

export class XPageSettingsSiteReactive
{
    static get type          () { return 'XPageSettingsSite';  }
    static get specification () 
    {
        return xObject({
            $: XPageSettingsSiteReactive.type,
            navbar: xObject({
                logo: xObject({
                    image: xReference('XImage'),
                    url: xString()
                }),
                logoBrand: xObject({
                    image: xReference('XImage'),
                    url: xString()
                }),
                languages: xArray(xObject({
                    label: xString(),
                    locale: xString()
                })),
                links: xArray(xObject({
                    label: xString(),
                    url: xString()
                }))
            }),
            footer: xObject({
                copyright: xObject({
                    label: xString(),
                    url: xString()
                }),
                updated: xObject({
                    label: xString(),
                    locale: xString()
                }),
                links: xArray(xObject({
                    label: xString(),
                    url: xString()
                }))
            }),
            themeColor: xString('#ffffff'),
            title: xString('Documentation', {
                localized: true
            }),
            titleMenu: xString('Menu', {
                localized: true
            }),
            titlePages: xString('Pages', {
                localized: true
            }),
            titleTOC: xString('On this page', {
                localized: true
            })
        });
    }

    static #template;

    static initDOM(domEnvironment)
    {
        this.#template = new XTemplateDOM(template, XPageSettingsSiteReactive.specification, domEnvironment);
    }

    #data;
    #dom;
    #page;

    constructor(data, page)
    {
        this.#data = data;
        this.#dom  = XPageSettingsSiteReactive.#template._createAccessibleDOM(data);
        this.#page = page;
    };

    get _dom () { return this.#dom;  }
    get page () { return this.#page; }
    get data () { return this.#data; }
};
xExtendClassForDOM(XPageSettingsSiteReactive);
